module.exports = __webpack_public_path__ + "static/media/seoppc.a62cc81d.jpg";